// extracted by mini-css-extract-plugin
export default {"gift-icon":"_1O4zF","giftIcon":"_1O4zF","wiggle":"_3VILo"};